<template>
    <div class="radio">
        <p>{{xuhao+"."+timu}}</p>
        <el-radio-group v-model="radio" class="el-radio-group">
            <el-radio v-if="options.length>0" :label="1" border class="item">{{options[0]}}</el-radio>
            <el-radio v-if="options.length>1" :label="2" border class="item">{{options[1]}}</el-radio>
            <el-radio v-if="options.length>2" :label="3" border class="item">{{options[2]}}</el-radio>
            <el-radio v-if="options.length>3" :label="4" border class="item">{{options[3]}}</el-radio>
            <el-radio v-if="options.length>4" :label="5" border class="item">{{options[4]}}</el-radio>
            <el-radio v-if="options.length>5" :label="6" border class="item">{{options[5]}}</el-radio>           
        </el-radio-group>
    </div>
</template>

<script>
export default {
name:"SingleTitle",
//  data () {
//       return {
//           radio: 1,
//       };
//     },
    props:['xuhao','timu','options','answer'],
    computed: {
        radio: {
            get() {
                if (this.answer == 'A') return 1;
                if (this.answer == 'B') return 2;
                if (this.answer == 'C') return 3;
                if (this.answer == 'D') return 4;
                if (this.answer == 'E') return 5;
                if (this.answer == 'F') return 6;
                return 0;
            }
        },
    }
}
</script>

<style scoped>
.radio{
    margin-top: 15px;
    border: 1px solid #E4EAF0;
    border-radius: 4px;
    padding: 10px 15px;
}
.radio:hover{
    border: 1px solid #1A8CFF;
}
.radio .item{
    margin-top: 8px;
}

.el-radio:nth-of-type(1)>:nth-child(2)::before{
   content:"A."
} 
.el-radio:nth-of-type(2)>:nth-child(2)::before{
   content:"B."
}
.el-radio:nth-of-type(3)>:nth-child(2)::before{
   content:"C."
} 
.el-radio:nth-of-type(4)>:nth-child(2)::before{
   content:"D."
}


.el-radio.is-bordered+.el-radio.is-bordered{
    margin-left: 0;
}
.radio p{
    font-size: 14px;
}
.el-radio {
     white-space: normal;
}
.el-radio.is-bordered{
    height:auto;
    width: 100%;
    padding:12px 20px;
}
.el-radio-group{
    display: block;
}
</style>>